import { call, put, takeEvery } from 'redux-saga/effects';
import { updateLeaderboardConfigRest } from '@/services/leaderboards/leaderboards-service';
import { toast } from 'react-toastify';
import { updateLeaderboardOverview, updateLeaderboardOverviewSuccess } from '../slices/leaderboards';
import { PayloadAction } from '@reduxjs/toolkit';
import { UpdateLeaderboardConfigBody } from '@repo/common-types';

export function* updateLeaderboardOverviewSaga(action: PayloadAction<UpdateLeaderboardConfigBody>) {
  const response = yield call(updateLeaderboardConfigRest, action.payload);
  toast.success('Leaderboard config updated successfully');
  yield put(updateLeaderboardOverviewSuccess(response));
}

export function* leaderboardSaga() {
  yield takeEvery(updateLeaderboardOverview, updateLeaderboardOverviewSaga);
}
